import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
const EvaluationItem = ({
  icon,
  title,
  subTitle,
  color,
  bgColor,
  borderBgColor
}: {
  icon: ReactElement;
  title: string;
  subTitle: string;
  bgColor: string;
  color: string;
  borderBgColor: string;
}) => {
  return <Box sx={{
    display: 'flex',
    flexDirection: 'row',
    bgcolor: bgColor,
    borderRadius: 'var(--corner_radius_xl)',
    gap: 'var(--spacing_xs)',
    p: 'var(--spacing_m)'
  }} data-sentry-element="Box" data-sentry-component="EvaluationItem" data-sentry-source-file="EvaluationItem.tsx">
      <Box sx={{
      display: 'flex',
      alignItems: 'center',
      p: 'var(--spacing_xs)',
      bgcolor: borderBgColor,
      height: 'fit-content',
      borderRadius: 'var(--corner_radius_xl)'
    }} data-sentry-element="Box" data-sentry-source-file="EvaluationItem.tsx">
        {icon}
      </Box>

      <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '100%'
    }} data-sentry-element="Box" data-sentry-source-file="EvaluationItem.tsx">
        <Typography sx={{
        typography: 'bodyMedium__Wallfund'
      }} color='text.text' data-sentry-element="Typography" data-sentry-source-file="EvaluationItem.tsx">
          {title}
        </Typography>
        <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 'var(--spacing_xxs)'
      }} data-sentry-element="Box" data-sentry-source-file="EvaluationItem.tsx">
          <Typography variant='headlineStrong__Wallfund' color={color} data-sentry-element="Typography" data-sentry-source-file="EvaluationItem.tsx">
            {subTitle}
          </Typography>
          <Typography variant='captionMedium__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="EvaluationItem.tsx">
            تومان
          </Typography>
        </Box>
      </Box>
    </Box>;
};
export default EvaluationItem;